import { AuthFormHeader } from "@/components/Auth/AuthFormHeader";
import { useNavigate } from "react-router-dom";
import { CreateShopButton } from "@/components/Onboarding/CreateShopButton";
import { useStore } from "@/stores/useStore";

export const RegistrationSuccess = () => {
  const navigate = useNavigate();
  const { allowedShops } = useStore();

  const handleCreateButtonClick = () => {
    navigate("/create-shop");
  };

  return (
    <div className="flex min-h-full items-center justify-center px-4 py-12 sm:px-6 lg:px-8">
      <div className="flex w-full max-w-md flex-col justify-center gap-4 space-y-8 rounded-xl border-2 border-white bg-secondary/10 p-8">
        <AuthFormHeader
          title={
            allowedShops.length === 0 ? "Congratulations!" : "Unverified Email"
          }
          instructions={
            allowedShops.length === 0
              ? "You have successfully registered! The next step is to create or join a shop! Click the button below to get started creating a shop."
              : "You need to verify your email address to continue."
          }
        />
        {allowedShops.length === 0 ? (
          <CreateShopButton onClick={handleCreateButtonClick} />
        ) : null}
      </div>
    </div>
  );
};
